import { Map } from 'immutable';
import actions from './actions';

const initState = new Map({
  team: null,
  loading: true,
  modalVisible: false,
  accessItem: null,
  inviteLoading: true,
  inviteMemberModalVisible: false,
  inviteMemberSending: false,
});

/* Re-inviting or resending reuses the same invite, so an incoming invite replaces its old copy. */
const upsertCompanyInvite = (state, invite) => {
  const team = state.get('team');
  if (!team || !invite) {
    return state;
  }
  const invites = (team.companyInvites || []).filter((item) => item.id !== invite.id);
  return state.set('team', { ...team, companyInvites: [invite, ...invites] });
};

export default function teamReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_TEAM_START:
      return state.set('loading', true);
    case actions.FETCH_TEAM_DONE:
      return state.set('team', action.payload).set('loading', false);
    case actions.FETCH_TEAM_ERROR:
      return state.set('loading', false);

    case actions.ITEM_MODIFY:
      return state.set('accessItem', action.payload);

    case actions.TOGGLE_MODAL:
      return state.set('modalVisible', action.payload);

    case actions.MUTATE_EMPLOYER_ACCESS_START: {
      const currentTeam = state.get('team');
      const { teamMembers } = currentTeam;

      const newTeamMembers = teamMembers.map((member) => {
        if (member.employer.id === action.payload.employerId) {
          return {
            ...member,
            access: member.access.map((access) => {
              return {
                ...access,
                allowed: action.payload[access.contentType],
              };
            }),
          };
        }
        return member;
      });

      const newTeam = {
        ...currentTeam,
        teamMembers: newTeamMembers,
      };

      return state.set('team', newTeam);
    }

    case actions.MUTATE_EMPLOYER_ACCESS_DONE:
      const currentTeam = state.get('team');
      const { teamMembers } = currentTeam;

      const newTeamMembers = teamMembers.map((member) =>
        member.id === action.payload.id ? action.payload : member
      );

      const newTeam = {
        ...currentTeam,
        teamMembers: newTeamMembers,
      };

      return state.set('team', newTeam);

    case actions.REDEEM_ACCESS_DONE:
    case actions.REDEEM_ACCESS_ERROR:
    case actions.REDEEM_ACCESS_CANCELLED:
      return state.set('inviteLoading', false);

    case actions.MUTATE_REVOKE_START: {
      if (state.get('team')) {
        const { invitedMembers } = state.get('team');
        return state.set('team', {
          ...state.get('team'),
          invitedMembers: invitedMembers.filter((member) => member.id !== action.payload.id),
        });
      }
      return state;
    }
    case actions.TOGGLE_INVITE_MEMBER_MODAL:
      return state.set('inviteMemberModalVisible', action.payload);

    case actions.INVITE_MEMBER_START:
      return state.set('inviteMemberSending', true);
    case actions.INVITE_MEMBER_DONE:
      return upsertCompanyInvite(state, action.payload)
        .set('inviteMemberSending', false)
        .set('inviteMemberModalVisible', false);
    case actions.INVITE_MEMBER_ERROR:
      return state.set('inviteMemberSending', false);

    case actions.RESEND_INVITE_DONE:
      return upsertCompanyInvite(state, action.payload);

    case actions.REVOKE_INVITE_DONE: {
      const team = state.get('team');
      if (!team) {
        return state;
      }
      return state.set('team', {
        ...team,
        companyInvites: (team.companyInvites || []).filter((item) => item.id !== action.payload.id),
      });
    }

    /* default logout handler */
    case 'LOGOUT':
      return initState;
    default:
      return state;
  }
}
